import { render } from "./profile_files.vue?vue&type=template&id=73b4253a"
import script from "./profile_files.vue?vue&type=script&lang=js"
export * from "./profile_files.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/user/profile/tabs/profile_files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73b4253a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73b4253a', __exports__)) {
    console.log('reload')
    api.reload('73b4253a', __exports__)
  }
  
  module.hot.accept("./profile_files.vue?vue&type=template&id=73b4253a", () => {
    console.log('re-render')
    api.rerender('73b4253a', render)
  })

}


export default __exports__